import { useEffect, useState } from 'react'

import { Tooltip } from '@material-ui/core'
import Switch from '@mui/material/Switch'
import {
  TableFooter,
  TableBodyStyled,
  TableCellStyled,
  TableContainerStyled,
  TableHeadStyled,
  TableRowStyled,
  TableStyled,
  CheckBox,
  Button,
  Row,
  Copy
} from 'components'
import { AttachmentFileIcon, StatusIcon } from 'components/Icons'
import { useModal } from 'hooks'
import { COLORS, FORMAT, SPACING } from 'utils'

interface ITableGenerateCre {
  tableData: any[]
  page: number
  setPage: (page: number) => void
  setRowsPerPage: (rowsPerPage: number) => void
  handleContractSelection: (
    contract: number,
    index: number,
    unCheckAll?: boolean,
    idsToExclude?: any[]
  ) => void
  selectedContractInfo: (contractId: number) => void
  handleGenerateCre: () => void
  handleIncludeCre: () => void
  rowsPerPage: number
  totalItems: number
  checkPages: boolean
  clearCheckAll: boolean
  setClearCheckAll: (clearCheckAll: boolean) => void
  setCheckPages: (checkPages: boolean) => void
  existingWallet: string
}
export const TableGenerateCre = ({
  tableData,
  setRowsPerPage,
  setPage,
  page,
  checkPages,
  setCheckPages,
  rowsPerPage,
  totalItems,
  clearCheckAll,
  setClearCheckAll,
  handleContractSelection,
  handleGenerateCre,
  selectedContractInfo,
  existingWallet,
  handleIncludeCre
}: ITableGenerateCre) => {
  const [checkAll, setCheckAll] = useState(false)
  const { showModal } = useModal()

  const INVALID_DATE = '01/01/0001'

  const handleChangePage = (newPage: number) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(1)
  }

  const handleStatusText = (text) => {
    if (text === 'Red') return 'Contrato Data vencida para análise'
    if (text === 'Yellow') return 'Contrato aguardando Análise Carteira'
    return 'Contrato não considerado Carteira'
  }

  const handleAction = (number) => {
    if (number > 0) return number + ' Anexos.'
    return 'Documentos não anexados'
  }

  const checkAllAction = () => {
    setCheckAll(!checkAll)
    setCheckPages(!checkPages)

    // Realizando check/uncheck dos contratos expostos na página atual
    if (checkAll === false) {
      tableData.map((row, index) => {
        row.checked = checkAll
        handleContractSelection(row.movimentacaoId, index)
      })
    } else {
      const idsToExclude = tableData.map((itens) => itens.movimentacaoId)
      tableData.map((row, index) => {
        row.checked = checkAll
        handleContractSelection(row.movimentacaoId, index, true, idsToExclude)
      })
    }
  }

  const handleGenerateCREConfirmation = () => {
    showModal({
      handleConfirm: () => handleGenerateCre(),
      message:
        'Após esta ação não conseguirá modificar novamente a carteira gerada.',
      titleModal: 'Atenção!',
      txtButtonCancel: 'VOLTAR',
      txtButtonConfirm: 'OK',
      type: 'alert'
    })
  }

  useEffect(() => {
    if (clearCheckAll) {
      setCheckAll(false)
      setCheckPages(false)
      setClearCheckAll(false)
    }
  }, [clearCheckAll])

  return (
    <>
      <TableContainerStyled>
        <TableStyled>
          <TableHeadStyled>
            <TableRowStyled>
              <TableCellStyled align="left">
                {' '}
                <CheckBox checked={checkAll} onClick={checkAllAction} />{' '}
              </TableCellStyled>
              <TableCellStyled align="left"></TableCellStyled>
              <TableCellStyled align="center">Contrato</TableCellStyled>
              <TableCellStyled align="center">Código Centro</TableCellStyled>
              <TableCellStyled align="left" minwidth="130px">
                Fornecedor
              </TableCellStyled>
              <TableCellStyled align="center">1ª Mob</TableCellStyled>
              <TableCellStyled align="center">Últ. Mob.</TableCellStyled>
              <TableCellStyled align="center">Denúncia</TableCellStyled>
              <TableCellStyled align="center">Projeto</TableCellStyled>
              <TableCellStyled align="center">Alerta</TableCellStyled>
              <TableCellStyled align="center">Últ. Análise</TableCellStyled>
              <TableCellStyled align="center">Valor Folha</TableCellStyled>
              <TableCellStyled align="center">Qtd. Efetivos</TableCellStyled>
              <TableCellStyled align="left">Status</TableCellStyled>
              <TableCellStyled align="left">Ação</TableCellStyled>
            </TableRowStyled>
          </TableHeadStyled>
          <TableBodyStyled>
            {tableData.length > 0 &&
              tableData.map((row, index) => (
                <TableRowStyled key={`${index}-${row.contrato}`}>
                  <TableCellStyled align="left">
                    <CheckBox
                      checked={row.checked}
                      onClick={() =>
                        handleContractSelection(row.movimentacaoId, index)
                      }
                    />
                  </TableCellStyled>
                  <TableCellStyled align="left">
                    <Copy
                      title="Copiar código de contrato"
                      valueToCopy={row.cdContrato}
                    />
                  </TableCellStyled>
                  <TableCellStyled align="left">
                    <Button
                      text={row.cdContrato}
                      textColor={COLORS.blueFonts}
                      variantButton="text"
                      onClick={() => selectedContractInfo(row.contratoId)}
                    />
                  </TableCellStyled>
                  <TableCellStyled align="center">{row.cdCentro || '-----'}</TableCellStyled>
                  <TableCellStyled align="left">
                    {row.nmFornecedor}
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    <Switch checked={row.flPrimeiraMob} />
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    <Switch checked={row.flUltMedicao} />
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    <Switch checked={row.flDenuncia} />
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    <Switch checked={row.flProjeto} />
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    <Switch checked={row.flAlerta} />
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    {row.dtUltAnaliseCre &&
                      FORMAT.formatDDMMYYYY(row.dtUltAnaliseCre) !== INVALID_DATE
                      ? FORMAT.formatDDMMYYYY(row.dtUltAnaliseCre)
                      : '---'}
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    {FORMAT.currency(row.vlFolhaPagto)}
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    {row.qtTotalEfetivo}
                  </TableCellStyled>
                  <Tooltip
                    title={handleStatusText(row.txStatusColor)}
                    arrow
                    placement="left"
                  >
                    <TableCellStyled status align="center" style={{ marginLeft: '3rem' }}>
                      <StatusIcon
                        marginLeft="0.75rem"
                        value={row.txStatusColor || 'LightGray'}
                      />
                    </TableCellStyled>
                  </Tooltip>

                  <Tooltip
                    title={handleAction(row.qtItensAnexados)}
                    arrow
                    placement="left"
                  >
                    <TableCellStyled status align='center' style={{ paddingLeft: '0.5rem' }}>
                      <AttachmentFileIcon
                        colorIcon={row.qtItensAnexados ? COLORS.black : COLORS.lightGray}
                      />
                    </TableCellStyled>
                  </Tooltip>
                </TableRowStyled>
              ))}
          </TableBodyStyled>
        </TableStyled>
      </TableContainerStyled>
      <TableFooter
        page={page}
        rows={tableData}
        totalItems={totalItems}
        rowsPerPage={rowsPerPage}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
      />
      <Row
        justifyContent="flex-end"
        alignItems="left"
        marginTop={SPACING.spacing15}
        marginBottom={SPACING.spacing10}
      >
        {existingWallet === 'checklist' ? (
          <Button
            text="Incluir Carteira"
            onClick={() => {
              setCheckAll(false)
              handleIncludeCre()
            }}
          />
        ) : (
          <Button
            text="Gerar Carteira"
            onClick={() => {
              setCheckAll(false)
              handleGenerateCREConfirmation()
            }}
          />
        )}
      </Row>
    </>
  )
}
